import React from "react";
import { Stack, Box, Typography, Slide, Divider } from "@mui/material";
import EmotionSelector from "../EmotionSelector";
import ControlPanel  from "../ControlPanel";

import "./SettingsSlider.css";

const SettingsSlider = ({ isSettingsOpen, options, setOptions }) => {
  return (
    // <Slide direction="left" in={isSettingsOpen} mountOnEnter unmountOnExit>
      <Box className="settingsBox" display={isSettingsOpen ? "block" : "none"}>
        <Typography variant="h6" marginBottom="15px"  color="text.secondary">
          Settings
        </Typography>
        <Divider />
        <Stack spacing={2} mt={2}>
          <EmotionSelector options={options} setOptions={setOptions} />
          <ControlPanel options={options} setOptions={setOptions} />
        </Stack>
      </Box>
    // </Slide>
  );
};

export default SettingsSlider;
